import React from "react";
import {
  Autocomplete,
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";

type ShipmentAutoCompleteFilterProps = {
  columnName: string;
  displayColumnName: string;
  value: string[];
  options: string[];
  onChange:
    | ((
        event: React.SyntheticEvent<Element, Event>,
        value: string[],
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<string> | undefined
      ) => void)
    | undefined;
};

const ShipmentAutoCompleteFilter = ({
  columnName,
  displayColumnName,
  value,
  options,
  onChange,
}: ShipmentAutoCompleteFilterProps) => {
  return (
    <Autocomplete
      filterSelectedOptions
      key={columnName}
      size="small"
      limitTags={3}
      multiple
      value={value}
      options={options}
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(option: string, value: string) => option === value}
      renderInput={(params) => (
        <TextField
          {...params}
          margin="normal"
          id={columnName}
          label={displayColumnName}
          name={columnName}
          size="small"
          fullWidth
        />
      )}
      onChange={onChange}
    />
  );
};

export default ShipmentAutoCompleteFilter;
